import { VendorData } from './Vendor';

export enum OcrMetadataStatus {
  IN_PROGRESS = 'In Progress',
  COMPLETED = 'Completed',
}

export type OcrMetaDataDto = {
  jobDocument: string;
  images: string[];
  status?: OcrMetadataStatus;
};

export type UpdateOcrMetaDataDto = Partial<OcrMetaDataDto>;

export type InvoiceData = {
  [key: string]: unknown;
  id: string;
  invoiceNumber: string;
  invoiceDate: string;
  received: string;
  comments: string;
  vendorId: string;
  vendor: VendorData;
  subtotal: string;
  salesTax: string;
  freight: string;
  totalAmountPayable: number | null;
  orgId: string;
  ocrMetadataId?: string | null;
  ocrMetadata?: OcrMetaDataDto;
  siteId: string;
  isActive: boolean;
  status: string;
  createdBy: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
  isCashPaidIn?: boolean;
  isCashPaidOut?: boolean;
  sourceFileName?: string;
};

export type InvoiceRequest = {
  result: InvoiceData[];
};

export enum InvoiceStatus {
  Draft = 'Draft',
  Accepted = 'Accepted',
  Finalized = 'Finalized',
}

export enum InvoiceStatusAction {
  Accepted = 'Accepted',
  Finalized = 'Finalized',
  Unfinalized = 'Unfinalized',
}

export enum MissingItemsDialogAction {
  None,
  Accept = 'Accept',
  Finalize = 'Finalize',
}

export enum InvoiceSource {
  Manual = 'Manual',
  Upload = 'Upload',
}

export type InvoiceRow = {
  [key: string]: unknown;
  id: string;
  invoiceNumber: string;
  source: InvoiceSource;
  vendorName: string;
  invoiceDate: string | null;
  received: string | null;
  total: string;
  status: InvoiceStatus;
  updatedAt: string;
  updatedBy: string;
};

export type InvoiceDto = {
  invoiceNumber: string;
  invoiceDate: string;
  received: string;
  comments?: string;
  vendorId?: string;
  subtotal?: number;
  salesTax?: number;
  freight?: number;
  totalAmountPayable?: number;
  isCashPaidIn?: boolean;
  isCashPaidOut?: boolean;
};

export type InvoiceUI = {
  invoiceId: string;
  vendorName: string;
  invoiceDate: Date;
  invoiceDeliverTime: Date;
  invoiceComments: string;
  isDraft: boolean;
  isCashPaidIn?: boolean;
  isCashPaidOut?: boolean;
};
